/* ============================================================
   PLANTILLA OREGANO · comportamiento compartido
   Carruseles, galería, cuenta atrás y vídeos.
   Se reinicializa solo al recargar secciones en el editor de Shopify.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- carruseles con flechas y puntos ---------- */
  function initRail(root) {
    root.querySelectorAll('[data-a-rail]').forEach(function (btn) {
      if (btn.dataset.oBound) return;
      btn.dataset.oBound = '1';
      btn.addEventListener('click', function () {
        var rail = root.querySelector('[data-a-rail-id="' + btn.dataset.oRail + '"]');
        if (!rail) return;
        var first = rail.firstElementChild;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
        var step = first ? first.getBoundingClientRect().width + gap : 220;
        rail.scrollBy({ left: step * Number(btn.dataset.oDir), behavior: 'smooth' });
      });
    });

    root.querySelectorAll('[data-a-rail-id]').forEach(function (rail) {
      if (rail.dataset.oBound) return;
      rail.dataset.oBound = '1';
      var dots = root.querySelector('[data-a-dots="' + rail.dataset.oRailId + '"]');
      if (!dots) return;
      rail.addEventListener('scroll', function () {
        var first = rail.firstElementChild;
        if (!first) return;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
        var i = Math.round(rail.scrollLeft / (first.getBoundingClientRect().width + gap));
        dots.querySelectorAll('i').forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }, { passive: true });
    });
  }

  /* ---------- galería de producto ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-a-gallery]').forEach(function (gal) {
      if (gal.dataset.oBound) return;
      gal.dataset.oBound = '1';
      var slides = gal.querySelectorAll('[data-a-slide]');
      var thumbs = gal.querySelectorAll('[data-a-thumb]');
      function show(i) {
        slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === i);
          t.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
      });
    });
  }

  /* ---------- cuenta atrás perpetua ---------- */
  function initCountdown(root) {
    root.querySelectorAll('[data-a-countdown]').forEach(function (el) {
      if (el.dataset.oBound) return;
      el.dataset.oBound = '1';

      var hours = parseFloat(el.dataset.oCountdown) || 24;
      var total = Math.max(60, Math.round(hours * 3600));
      var key = 'anelvia-cd-' + (el.dataset.oKey || 'default');
      var end;

      try {
        var saved = parseInt(localStorage.getItem(key), 10);
        if (saved && saved > Date.now()) { end = saved; }
      } catch (e) { /* modo privado: se usa una cuenta atrás de sesión */ }

      if (!end) {
        end = Date.now() + total * 1000;
        try { localStorage.setItem(key, String(end)); } catch (e) {}
      }

      var out = {
        h: el.querySelector('[data-a-cd="h"]'),
        m: el.querySelector('[data-a-cd="m"]'),
        s: el.querySelector('[data-a-cd="s"]')
      };
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };

      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {                       // al agotarse vuelve a empezar
          end = Date.now() + total * 1000;
          try { localStorage.setItem(key, String(end)); } catch (e) {}
          left = total;
        }
        if (out.h) out.h.textContent = pad(Math.floor(left / 3600));
        if (out.m) out.m.textContent = pad(Math.floor((left % 3600) / 60));
        if (out.s) out.s.textContent = pad(left % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- tarjetas de vídeo ---------- */
  function initVideos(root) {
    root.querySelectorAll('[data-a-video]').forEach(function (card) {
      if (card.dataset.oBound) return;
      card.dataset.oBound = '1';
      card.addEventListener('click', function () {
        var v = card.querySelector('video');
        if (!v) return;
        var play = card.querySelector('.a-play');
        if (v.paused) { v.play(); if (play) play.style.display = 'none'; }
        else { v.pause(); if (play) play.style.display = ''; }
      });
    });
  }

  /* ---------- selector de packs ---------- */
  function initBundles(raiz) {
    raiz.querySelectorAll('.a-bundle').forEach(function (b) {
      if (b.dataset.aBound) return;
      b.dataset.aBound = '1';
      b.addEventListener('click', function () {
        b.parentNode.querySelectorAll('.a-bundle').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initRail(root);
    initGallery(root);
    initCountdown(root);
    initVideos(root);
    initBundles(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* el editor de Shopify recarga secciones sueltas */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
